import {useDispatch} from "react-redux";
import {CSSTransition} from 'react-transition-group';
import {setDrawerLogin} from "../../reducer/actions";
import Mask from "../Mask";
import {useEffect} from "react";

export default function Drawer(props) {
  const {
    children, style, wrapClassName,
    visible, left, top, width, offsetTop,
    onToggle, onClose, maskStyle,
    theme
  } = props;
  
  const isMdmax = window.matchMedia('(max-width:768px)').matches;
  
  const drawerBgColor = theme === 'dark' ? '#444' : '#fff';
  
  useEffect(() => {
    return () => {
    };
  }, []);
  
  return (
    <>
      <Mask visible={visible}
            offsetTop={offsetTop}
            onToggle={onToggle}
            style={maskStyle}
            onClose={onClose}/>
      <CSSTransition in={visible}
                     classNames={left ? 'slideLeftIn' : top ? 'slideTopIn' : 'slideRightIn'}
                     timeout={350}
                     unmountOnExit={true}>
        <div className={`md:max-w-[500px] mdmax::max-w-[100vw] md:min-w-[300px] w-[40%] h-[100vh] p-[20px] pt-[10px] bg-white fixed top-0 z-50 ${left ? 'left-0' : 'right-0'} ${wrapClassName}`}
             style={{
               backgroundColor: drawerBgColor,
               boxShadow: isMdmax ? 'none' : '-1px 0 6px rgba(0,0,0,.16)',
               width: width ? width : '',
               marginTop: offsetTop,
               ...style
             }}>
          {children}
        </div>
      </CSSTransition>
    </>
  );
}
